
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectStakeholderDto extends EpimsBaseEntityDto {

  @IsNotEmpty() ProjectStakeholderId?: string;
  @IsNotEmpty() StakeholderName: string;
  @IsNotEmpty() StakeholderTypeId?: string;
  @IsNotEmpty() StakeholderRole: string;
  @IsNotEmpty() StakeholderAddress: string;
  @IsNotEmpty() StakeholderId: string;
  @IsNotEmpty() StakeholderTypeName?: string;
  @IsNotEmpty() ProjectId: string;


}
